import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Check, X, BadgeCheck } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { countryFlag } from "@/lib/places";
import { toast } from "sonner";

export default function FriendRequestsPage() {
  const nav = useNavigate();
  const { user, setAuthOpen } = useAuth();
  const [reqs, setReqs] = useState([]);

  useEffect(() => { if (user === false) setAuthOpen(true); }, [user, setAuthOpen]);
  const load = () => api.get("/friends/requests").then((r) => setReqs(r.data)).catch(() => {});
  useEffect(() => { if (user && user !== false) load(); }, [user]);

  if (!user || user === false) return <div className="p-8 text-center text-slate-500">Kyçu për të parë kërkesat.</div>;

  const respond = async (id, accept) => {
    await api.post(`/friends/respond/${id}`, { accept });
    setReqs((r) => r.filter((x) => x.id !== id));
    toast.success(accept ? "Kërkesa u pranua" : "Kërkesa u refuzua");
  };

  return (
    <div className="gs-fade px-4 pt-4 pb-6" data-testid="requests-page">
      <button onClick={() => nav("/profil")} className="flex items-center gap-1 text-sm text-slate-500 mb-2"><ArrowLeft className="w-4 h-4" />Profili</button>
      <h1 className="text-2xl font-extrabold text-slate-900 mb-3">Kërkesat për shoqëri</h1>
      <div className="space-y-2">
        {reqs.map((p) => (
          <div key={p.id} className="flex items-center gap-3 bg-white rounded-2xl p-2.5 border border-slate-100">
            <button onClick={() => nav(`/perdorues/${p.id}`)} className="w-11 h-11 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center font-bold overflow-hidden shrink-0">
              {p.avatar ? <img src={p.avatar} alt="" className="w-full h-full object-cover" /> : (p.name?.[0] || "?")}
            </button>
            <div className="flex-1 min-w-0" onClick={() => nav(`/perdorues/${p.id}`)}>
              <div className="flex items-center gap-1"><span className="font-semibold text-sm text-slate-800 truncate">{p.name} {p.surname}</span>{p.verified && <BadgeCheck className="w-4 h-4 text-sky-500" />}</div>
              <div className="text-xs text-slate-400 truncate">{countryFlag(p.country)} {p.city}</div>
            </div>
            <button data-testid={`accept-${p.id}`} onClick={() => respond(p.id, true)} className="bg-emerald-500 text-white rounded-lg p-2"><Check className="w-4 h-4" /></button>
            <button data-testid={`reject-${p.id}`} onClick={() => respond(p.id, false)} className="bg-slate-100 text-slate-500 rounded-lg p-2"><X className="w-4 h-4" /></button>
          </div>
        ))}
        {!reqs.length && <p className="text-center text-slate-400 py-10 text-sm">Asnjë kërkesë e re.</p>}
      </div>
    </div>
  );
}
